// import React from 'react';
// import Highcharts, { color } from 'highcharts';
// import HighchartsReact from 'highcharts-react-official';
import { useQuery } from "@tanstack/react-query";
import { getSaffronReport } from "@services/api";
import annotationPlugin from "chartjs-plugin-annotation";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { hejriDate } from "@helpers/financial_helper";

const IrrigationChart = ({ id, firstDate, endDate }) => {
  const getSaffronReportQuery = useQuery({
    queryKey: ["getSaffronReportQuery", id],
    queryFn: () => getSaffronReport(id),
  });

  const minTemperature =
    getSaffronReportQuery?.data?.firstSaffronIrrigationDateRecommendation?.dailyClimaticData?.map(
      (minTemp) => {
        return minTemp.minTemperature;
      }
    );

  const maxTemperature =
    getSaffronReportQuery?.data?.firstSaffronIrrigationDateRecommendation?.dailyClimaticData?.map(
      (maxTemp) => {
        return maxTemp.maxTemperature;
      }
    );

  const precipitation =
    getSaffronReportQuery?.data?.firstSaffronIrrigationDateRecommendation?.dailyClimaticData?.map(
      (prcpn) => {
        return prcpn.precipitation;
      }
    );

  const localTime =
    getSaffronReportQuery?.data?.firstSaffronIrrigationDateRecommendation?.dailyClimaticData?.map(
      (date) => {
        return hejriDate(date.localTime);
      }
    );

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    annotationPlugin
  );

  const data = {
    labels: localTime,
    datasets: [
      {
        label: "حداکثر دمای روزانه",
        data: maxTemperature,
        borderColor: "#1E90FF",
        backgroundColor: "#1E90FF",
        borderWidth: 2,
        fill: false,
        tension: 0.4,
      },
      {
        label: "حداقل دمای روزانه",
        data: minTemperature,
        borderColor: "#FFA500",
        backgroundColor: "#FFA500",
        borderWidth: 2,
        fill: false,
        tension: 0.4,
      },
      {
        label: "بارش روزانه",
        data: precipitation,
        borderColor: "#808080",
        backgroundColor: "#808080",
        borderWidth: 2,
        fill: false,
        tension: 0.4,
        yAxisID: "y-axis-2",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: {
            size: 14,
            family: " B-NAZANIN",
          },
          color: "#333333",
        },
      },
      title: {
        display: true,
        // text: 'Weather Data',
        font: {
          size: 18,
          family: "B-NAZANIN",
        },
        color: "#333333",
      },
      annotation: {
        annotations: {
          box1: {
            type: "box",
            xMin: hejriDate(firstDate), // تاریخ شروع هایلایت
            xMax: hejriDate(endDate), // تاریخ پایان هایلایت
            backgroundColor: "rgba(75, 192, 192, 0.4)", // رنگ ناحیه هایلایت
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 2,
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "تاریخ شمسی",
          color: "#333333",
          font: {
            size: 12,
            family: "B-NAZANIN",
          },
        },
        ticks: {
          color: "#666666",
          font: {
            size: 10,
          },
        },
      },
      y: {
        type: "linear",
        display: true,
        position: "left",
        title: {
          display: true,
          text: "دما (درجه سانتی‌گراد)",
          color: "#333333",
          font: {
            size: 14,
            family: "B-NAZANIN",
          },
        },
        ticks: {
          color: "#666666",
          font: {
            size: 12,
          },
        },
        stepSize: 5, // فاصله بین اعداد محور Y چپ
        min: 0, // مقدار حداقل محور Y چپ
        // max: 40, // مقدار حداکثر محور Y چپ
      },
      "y-axis-2": {
        type: "linear",
        display: true,
        position: "right",
        title: {
          display: true,
          text: "بارش (میلی متر)",
          color: "#333333",
          font: {
            size: 16,
            family: "B-NAZANIN",
          },
        },
        ticks: {
          color: "#666666",
          font: {
            size: 12,
          },
        },
        stepSize: 5, // فاصله بین اعداد محور Y چپ
        min: 0, // مقدار حداقل محور Y چپ
        // max: 2.5, // مقدار حداکثر محور Y چپ
        grid: {
          drawOnChartArea: false,
        },
      },
    },
  };

  return (
    <div className="w-[600px] h-[300px] -mt-8">
      <Line data={data} options={options} />
    </div>
  );
};

export default IrrigationChart;
